import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { Button } from "../../components/ui/button";
import { joinUrlWithParamsId } from "../../helpers/joinParam";
import { useNavigate } from "react-router-dom";
import usequotation from "../../store/quotation/storeQuotation";

interface ModalProps {
  isVisible: boolean;
  onClose: () => void;
}

const ModalComponent: React.FC<ModalProps> = ({ isVisible, onClose }) => {
  const { t } = useTranslation();
  const { quotation_id } = usequotation();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Quotation ID:", quotation_id);
  }, [quotation_id]);

  if (!isVisible) return null;

  console.log("AllQuotation", quotation_id);

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <div className="flex justify-between items-center">
          <h3 className="text-lg mx-auto">
            {t('quotationModal.requestRegistered')}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            &times;
          </button>
        </div>
        <div className="mt-4">
          <p className="text-gray-400 text-sm text-center">
            {t('quotationModal.responseMessage')}
          </p>
        </div>
        <div className="flex justify-center mt-6">
          <Button
            className="bg-yellow-500 text-black p-2 rounded hover:bg-green-600 w-[250px]"
            style={{ borderRadius: "50px", height: "2em" }}
            onClick={() =>
              navigate(
                joinUrlWithParamsId("/details_quaotation/:id", quotation_id)
              )
            }
          >
            {t('quotationModal.viewCarrierRequest')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModalComponent;